module.exports = __webpack_public_path__ + "static/baby-faaf5185b94f325385add39011b955cf.svg";